
import { DisabledPrompt, useModel } from "@bcm-dev/bcms-vite";
import { TableItemContainer, TableItemTextView, TableItemView } from "components/shared";
import { UICheckbox } from "components/ui";
import { SVGAsset } from "res";

import "./styles.css";

export default function PendingWireWidgetTableRow(props) {
    const oneTimeWireTransfer = props.oneTimeWireTransfer ?? {};
    const fundingAccount = `${ oneTimeWireTransfer.wireFundingAccount.number } - ${ oneTimeWireTransfer.wireFundingAccount.name }`;
    const { branding } = useModel() ?? {};
    const { options } = branding ?? {};
    const hasNotifyPayeeColumn = options.pending_wires_notify_payee_abi22 === "true";
    const notifyPayee = oneTimeWireTransfer.notifyPayee ? "Yes" : "No";
    const action = props.action ?? {};
    const { pendingWireCheckedRow } = action;
    const rowId = props.rowId ?? "";
    
    return (
        <TableItemContainer>
            <TableItemView className="ui-checkbox-column">
                <UICheckbox label="" value={ oneTimeWireTransfer.isChecked }  onChange={pendingWireCheckedRow( oneTimeWireTransfer.id)}  dataPoint={`Pending_Wire_Checkbox_${rowId}`}/>
            </TableItemView>
                 <TableItemView className="ref-number-text" dataPoint={`Pending_Wire_Reference_Number_${rowId}`}>
                    <p className="detail-text ref-number">{ oneTimeWireTransfer.referenceNumber }</p>
                    <p className="detail-text approval-required-text">Approval Required By System</p>
                 </TableItemView> 
            <TableItemView className="payee-text" dataPoint={`Pending_Wire_Payee_${rowId}`}>
                <div className="text-container">
                    <p className="payee-detail detail">
                        <span className="detail-label">Payee: </span> <span className="detail-text">{ oneTimeWireTransfer.name }</span>
                    </p>
                    <p className="funding-account-detail detail">
                        <span className="detail-label">Funding Account: </span> <span className="detail-text">{ fundingAccount }</span>
                    </p>
                    <p className="ref-number-detail detail">
                        <span className="detail-label">Ref #: </span> <span className="detail-text">{ oneTimeWireTransfer.referenceNumber }</span>
                    </p>
                    
                    {/* Reason for payment detail row is shown if a reason is provided */}
                    { oneTimeWireTransfer.reasonForPayment !== "" && 
                    <p className="reason-detail detail">
                        <span className="detail-label">Reason for Payment: </span> <span className="detail-text">{ oneTimeWireTransfer.reasonForPayment }</span>
                    </p>
                    }
                    {/* Memo detail row is shown if a memo is provided */}
                    { oneTimeWireTransfer.memo !== "" && 
                    <p className="memo-detail detail">
                        <span className="detail-label">Memo: </span> <span className="detail-text">{ oneTimeWireTransfer.memo }</span>
                    </p>
                    }
                </div>
            </TableItemView>
            { hasNotifyPayeeColumn && <TableItemTextView className="notify-payee-text" text={ notifyPayee } /> }
            <TableItemTextView className="amount-text" text={ oneTimeWireTransfer.amount.format() } />

            <TableItemView className="status-text">
                <div className="text-container">
                    <p className="status-detail detail">
                        <span className="detail-label">Pending Approval(s): </span><span className="detail-text">{ oneTimeWireTransfer.numberOfPendingApprovals }</span>
                    </p>
                </div>
            </TableItemView>
            <TableItemTextView className="wire-date" text={ oneTimeWireTransfer.date.format("m/d/Y") } />
            <TableItemTextView className="initiated-by-text" text={ oneTimeWireTransfer.initiatedBy } />
            <TableItemView className="comment-text" dataPoint={`Pending_Wire_Comment_${rowId}`}>
                <textarea className="comment-text-area" />
            </TableItemView>
            <TableItemView className="actions-column">
                <DisabledPrompt>
                    <SVGAsset id="MagnifyingGlassIcon" className="magnifying-glass-icon clickable"  data-point={`Pending_Wire_Search_${rowId}`}/>
                </DisabledPrompt>
                {/* <DisabledPrompt>
                    <SVGAsset id="TrashcanXIcon" className="trash-can-x-icon clickable" />
                </DisabledPrompt> */}

            </TableItemView>
        </TableItemContainer>
    )
}
